module.exports = __webpack_public_path__ + "img/bz.e097a65e.jpg";